
import { Component, Prop, Vue, Watch, Emit, Mixins } from 'vue-property-decorator';
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import multiselect from 'vue-multiselect';
import { getDateAsMoment } from '../../../../../features/core/utils/dates';
import { dateTypes } from '../../../../../features/typescript/dates/date-models';

@Component({
    components: {
        multiselect
    }
})
export default class DatePickerRange extends Vue {
    rangeDate: Date[] = [];
    @Prop() visible: boolean;
    @Prop() label: string;
    @Prop() rangeSelected: Date[];
    @Prop({ default: false }) activeButton: boolean;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: false }) clearableEndDate: boolean;
    @Prop({ default: false }) clearableStartDate: boolean;
    @Prop({ default(){return [
        'Fecha de Inicio',
        'Fecha de Fin'
    ]} }) labels: string;
    dateStart: string = '';
    dateEnd: string = '';
    rangeDateStart: string = '';
    rangeDateFinish: string = '';
    rangeSelectedIsValid: any = '';
    menu: boolean = true;
    hoursSelector: any = [];
    showComponent: boolean = false;
    errorEndDate: boolean = false;
    showSelectors: boolean = false;
    maxDaysLimit: number = 7;

    mounted() {
        this.loadRangeDate(this.rangeSelected);
    }

    focusDateStart() {
        this.closeDatePickers();
    }

    focusDateEnd() {
        this.closeDatePickers();
    }

    closeDatePickers() {
        let menuElement1 = this.$refs.rangeDateStart as HTMLFormElement;
        let menuElement2 = this.$refs.rangeDateFinish as HTMLFormElement;
        menuElement1.save(this.dateStart);
        menuElement2.save(this.dateEnd);
    }

    get getSummaryIcon() {
        if (!this.existAnyDateRange) {
            if (this.showSelectors) {
                return 'mdi-arrow-collapse-up';
            } else {
                return 'mdi-calendar';
            }
        } else {
            return 'mdi-close';
        }
    }

    get checkIfAreFieldAreFilled() {
        if (this.dateStart && this.dateEnd) {
            return true;
        } else {
            return false;
        }
    }

    get existAnyDateRange() {
        if (this.rangeSelected.length > 0) {
            return true;
        } else {
            return false;
        }
    }

    get getSummaryText() {
        if (this.rangeSelected.length > 0) {
            if (this.rangeSelected[0] && this.dateStart === '') {
                this.dateStart = moment(this.rangeSelected[0]).format('YYYY-MM-DD');
            }
            if (this.rangeSelected[1] && this.dateEnd === '') {
                this.dateEnd = moment(this.rangeSelected[1]).format('YYYY-MM-DD');
            }
            return this.formatTimeStamp(this.rangeSelected[0]) + ' ~ ' + this.formatTimeStamp(this.rangeSelected[1]);
        } else {
            return 'Seleccionar rango de fechas';
        }
    }

    loadRangeDate(dateRange){
        if (dateRange.length > 0) {
            this.dateStart = dateRange[0] !== '' ? moment(dateRange[0]).format('YYYY-MM-DD') : '';
            this.dateEnd = dateRange[1] !== '' ? moment(dateRange[1]).format('YYYY-MM-DD') : '';
            if(dateRange[0] !== '' && dateRange[1] !== ''){
                this.checkIfRangeDateIsValid();
            }   
        } else {
            this.clearDate();
        }
    }

    @Watch('rangeSelected')
    watchRangeSelected(dateRange) {
        this.loadRangeDate(dateRange);
    }

    get getHoursOptions() {
        for (let hour = 0; hour < 24; hour++) {
            this.hoursSelector.push(moment({ hour, minute: 0 }).format('HH:mm'));
            this.hoursSelector.push(moment({ hour, minute: 15 }).format('HH:mm'));
            this.hoursSelector.push(moment({ hour, minute: 30 }).format('HH:mm'));
            this.hoursSelector.push(moment({ hour, minute: 45 }).format('HH:mm'));
            this.hoursSelector.push(moment({ hour, minute: 55 }).format('HH:mm'));
        }
        return this.hoursSelector;
    }

    @Watch('dateEnd')
    observableDateEnd(date) {
        this.applyFilter(false);
        // this.checkIfRangeDateIsValid();
    }

    @Watch('dateStart')
    observableDateStart(date) {
        if (this.dateEnd !== '') {
            this.applyFilter(false);
        }
        // this.checkIfRangeDateIsValid();
    }

    updateClearableEndDate(){
        this.dateEnd = '';
        this.changeDateRange();
    }
    updateClearableStartDate(){
        this.dateStart = '';
        this.changeDateRange();
    }

    clearDate() {
        this.dateStart = '';
        this.dateEnd = '';
        this.clearErrors();
    }

    resetFilter() {
        this.clearDate();
        this.clearErrors();
        let rangeDate = {
            datetime_from: '',
            datetime_to: ''
        };
        this.showSelectors = true;
        localStorage.removeItem('filteredDateRange');
    }

    clearErrors() {
        this.errorEndDate = false;
    }

    checkIfRangeDateIsValid() {
        this.clearErrors();
        this.rangeSelectedIsValid = false;
        if (this.dateStart && this.dateEnd) {
            let dateFrom: any = getDateAsMoment(this.getStartDate, dateTypes.globalFilterDateFormat);
            let dateTo: any = getDateAsMoment(this.getEndDate, dateTypes.globalFilterDateFormat);
            let endDateIsValid = moment(this.dateEnd).isSameOrAfter(moment(this.dateStart));
            let endTimeIsNotValid = moment(this.dateEnd).isSame(this.dateStart);
            //compruebo que la fecha de fin sea la misma o posterior a la inicial

            this.validDateAndHours(endDateIsValid, endTimeIsNotValid);
        } else {
            this.rangeSelectedIsValid = false;
        }
    }

    validDateAndHours(endDateIsValid, endTimeIsNotValid) {
        if (!endDateIsValid) {
            //this.$_showHistoricalError('La fecha de fin debe ser posterior o igual a la inicial');
            this.errorEndDate = true;
            this.rangeSelectedIsValid = false;
        } else {
            this.rangeSelectedIsValid = true;
        }
    }


    get getStartDate() {
        return this.dateStart !== '' ? this.dateStart + 'T00:00:00' : '';
    }

    get getEndDate() {
        return this.dateEnd !== '' ? this.dateEnd + 'T23:59:00' : '';
    }

    @Emit()
    changeDateRange(){
        let datetimeFrom = this.getStartDate
        let datetimeTo = this.getEndDate
        return [datetimeFrom, datetimeTo]
    }

    applyFilter(hideContent) {
        this.checkIfRangeDateIsValid();
        if (this.rangeSelectedIsValid) {
            this.changeDateRange();
        }
    }

    formatTimeStamp(date) {
        return moment(date, 'YYYY-MM-DDTHH:mm:ss').format('DD/MM/YYYY HH:mm');
    }

    formatDate(date) {
        if (date && date !== null) {
            return moment(date).format('DD/MM/YYYY');
        } else {
            return null;
        }
    }

    datePickerValidation(val) {
        if (val == null || val == undefined) {
            return '';
        } else if (!this.checkDate(val)) {
            return '';
        } else if (val.length > 10) {
            return '';
        } else {
            return true;
        }
    }

    checkDate(date) {
        if (date.length !== 10) {
            return false;
        } else {
            let years = moment().diff(date, 'years');
            if (years > 100 || years < 0) {
                return false;
            } else {
                return true;
            }
        }
    }

    saveStartDate(date, refMenu) {
        let formattedDate = date ? moment(date).format('DD/MM/YYYY') : null;
        let menuElement = this.$refs.rangeDateStart as HTMLFormElement;
        menuElement.save(formattedDate);
    }

    saveEndDate(date, refMenu) {
        let formattedDate = date ? moment(date).format('DD/MM/YYYY') : null;
        let menuElement = this.$refs.rangeDateFinish as HTMLFormElement;
        menuElement.save(formattedDate);
    }

    validateTime(time) {
        return moment(time, 'HH:mm', true);
    }


    toggleMenuVisibility() {
        this.showSelectors = !this.showSelectors;
    }

    clickDateButton(item) {
        this.$emit('click-filter-button', item);

        if (this.existAnyDateRange) {
            this.showSelectors = false;
            this.applyFilter(false);
        }
    }
}
